import Axios from 'axios'
import { headers } from '../../../../utilities/token'

export const POST_POST = 'POST_POST'
export const POST_POST_FULFILLED = 'POST_POST_FULFILLED'
export const POST_POST_REJECTED = 'POST_POST_REJECTED'
export const GET_POSTS = 'GET_POSTS'
export const GET_POSTS_FULFILLED = 'GET_POSTS_FULFILLED'
export const GET_POSTS_REJECTED = 'GET_POSTS_REJECTED'
export const PUT_POST = 'PUT_POST'
export const PUT_POST_FULFILLED = 'PUT_POST_FULFILLED'
export const PUT_POST_REJECTED = 'PUT_POST_REJECTED'
export const DELETE_POST = 'DELETE_POST'
export const DELETE_POST_FULFILLED = 'DELETE_POST_FULFILLED'
export const DELETE_POST_REJECTED = 'DELETE_POST_REJECTED'
export const POST_COMMENT = 'POST_COMMENT'
export const POST_COMMENT_FULFILLED = 'POST_COMMENT_FULFILLED'
export const POST_COMMENT_REJECTED = 'POST_COMMENT_REJECTED'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const DELETE_COMMENT_FULFILLED = 'DELETE_COMMENT_FULFILLED'
export const DELETE_COMMENT_REJECTED = 'DELETE_COMMENT_REJECTED'

const API_URL = process.env.REACT_APP_API_BASE_URL

export const loadPost = (pagination) => {
  return dispatch => {
    dispatch({
      type: GET_POSTS,
      payload: {}
    })
    return Axios.get(`${API_URL}/posts?page=${pagination.page}&limit=${pagination.limit}&searchTerm=${pagination.searchTerm}`, { headers: headers })
      .then(function (response) {
        dispatch({
          type: GET_POSTS_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: GET_POSTS_REJECTED,
          payload: error
        })
      })
  }
}

export const submitPost = (data) => {
  return dispatch => {
    dispatch({
      type: POST_POST,
      payload: {}
    })
    return Axios.post(`${API_URL}/post`, { ...data }, { headers: headers })
      .then(function (response) {
        dispatch({
          type: POST_POST_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: POST_POST_REJECTED,
          payload: error
        })
      })
  }
}

export const updatePost = (data) => {
  return dispatch => {
    dispatch({
      type: PUT_POST,
      payload: {}
    })
    return Axios.put(`${API_URL}/post/${data.id}`, { ...data }, { headers: headers })
      .then(function (response) {
        dispatch({
          type: PUT_POST_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: PUT_POST_REJECTED,
          payload: error
        })
      })
  }
}

export const approvedPost = (data) => {
  return dispatch => {
    dispatch({
      type: PUT_POST,
      payload: {}
    })
    return Axios.put(`${API_URL}/post-approved/${data.id}`, { ...data }, { headers: headers })
      .then(function (response) {
        dispatch({
          type: PUT_POST_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: PUT_POST_REJECTED,
          payload: error
        })
      })
  }
}

export const deletePost = (id) => {
  return dispatch => {
    dispatch({
      type: DELETE_POST,
      payload: {}
    })
    return Axios.delete(`${API_URL}/post/${id}`, { headers: headers })
      .then(function (response) {
        dispatch({
          type: DELETE_POST_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: DELETE_POST_REJECTED,
          payload: error
        })
      })
  }
}

export const submitComments = (data) => {
  return dispatch => {
    dispatch({
      type: POST_COMMENT,
      payload: {}
    })
    return Axios.post(`${API_URL}/comment`, { ...data }, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: POST_COMMENT_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: POST_COMMENT_REJECTED,
          payload: error
        })
      })
  }
}

export const deleteComment = (commentId) => {
  return dispatch => {
    dispatch({
      type: DELETE_COMMENT,
      payload: {}
    })
    return Axios.delete(`${API_URL}/comment/${commentId} `, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: DELETE_COMMENT_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: DELETE_COMMENT_REJECTED,
          payload: error
        })
      })
  }
}






